<template>
  <div class="documents">
    <div class="documents__content">
      <SectionHeader>Documents</SectionHeader>
      <div class="documents__files-list">
        <a
          v-for="doc in getDocuments"
          :key="doc.url"
          :href="doc.url" 
          target="_blank"
          class="documents__file"
        >
          <span class="documents__file-extension">PDF</span>
          <span class="documents__file-name">{{ doc.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';

  export default {
    name: 'Documents',
    components: {
      SectionHeader
    },
    computed: {
      ...mapGetters('tour', ['getDocuments'])
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .documents {
    $self: &;

    background-color: var(--primary-section-color);

    &__content {
      @include layoutContent();
      @include layoutHPadding();
      @include layoutVPadding();
    }

    &__file {
      text-decoration: none;
      margin: 20px;
      font-size: 16px;
      display: flex;
      &:hover,
      &:focus {
        #{$self}__file-name {
          text-decoration: underline;
          color: var(--primary-color);
        }
      }
    }

    &__file-extension {
      background-color: var(--documents-icon-color);
      padding: 5px 7px 4px;
      margin-right: 10px;
      color: white;
      font-size: 14px;
      line-height: 1;
      display: inline-block;
    }

    &__file-name {
      color: var(--documents-file-name-color);
      display: inline-block;
      margin-top: auto;
      margin-bottom: auto;
    }

    @include mdScreen() {
      &__files-list {
        margin: auto -20px auto -20px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
      }

      &__file {
        margin: 20px;
      }
    }
  }
</style>
